import StoreTotalRow from './StoreTotalRow'

export default StoreTotalRow
